export default "__VITE_ASSET__Crmbl3X0__"